module.exports = __webpack_public_path__ + "static/img/background.be67b564.jpg";